import { createBrowserRouter, Navigate } from 'react-router-dom';
import { lazy } from 'react';

import { Loadable } from '../components/Loadable';
import authRoutes from './authRoutes';
import mainRoutes from './mainRoutes';
import publicRoutes from './publicRoutes';
import ErrorPage1 from '../components/Pages/Others/ErrorPage/ErrorPage1';
import ErrorPage4 from '../components/Pages/Others/ErrorPage/ErrorPage4';
import ErrorPage6 from '../components/Pages/Others/ErrorPage/ErrorPage6';

const VerifyEmail = Loadable(lazy(() => import('../pages/auth/VerifyEmail')));

const router = createBrowserRouter([
   {
      path: '/',
      element: <Navigate to={'/auth/login'} />,
   },
   {
      path: '/dashboard/auth/verify-email',
      element: <VerifyEmail />,
   },
   authRoutes,
   mainRoutes,
   publicRoutes,
   {
      path: 'error/404',
      element: <ErrorPage4 />,
   },
   {
      path: 'error/500',
      element: <ErrorPage1 />,
   },
   {
      path: 'error/unauthorized',
      element: <ErrorPage6 />,
   },
   {
      path: '*',
      element: <ErrorPage4 />,
   },
]);

export default router;
